import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {
  applicationStageAllowGenerateContract,
  BusinessLoansApplication,
  ContractDetails,
  CreateApplicationNoteFn,
  CreateNewDisbursementFn,
  DeclineContractFn,
  DeleteContractFileFn,
  GenerateContractFn,
  GetActiveContractForApplicationFn,
  GetContractStatusFn,
  GetDisbursementByApplicationIdFn,
  SendContractEmailsFn,
  SyncBankDetailsToSfFn,
  SyncContractDetailsToSfFn,
  SyncDisbursementToSfFn,
  UpdateDisbursementFn,
  RemoveApplicationNoteByNoteIdFn,
  User,
  getPaymentType,
  GetBillerNameFn,
  ValidateBPAYFn,
  UpdateApplicationStageInSfFn,
  GetApplicationByIdFn,
  AzureStorageDocument,
  Application,
  GroupedDocument,
  ApiResponse,
  formGroupedDocumentData,
  unclassifiedDocuments,
  applicationStageAllowSettleLoan,
  Disbursement,
  validateDisbursementData,
  SettleLoanFn,
  GetInstitutionNameFn,
  GetBankDetailsFromOpportunitySfFn,
  GenerateApprovalNoticeFn,
  SendApprovalNoticeEmailFn,
  DeleteApprovalNoticeFileFn,
  RefreshBankStatementFn,
  GetUserFn,
  GetAccountDetailsFromSfFn,
  GetLvrCalculatorValueFn,
  UpdateLvrCalculatorValueFn,
  isAdminOrCreditUserOrSalesAM,
  UpdateApplicationFn,
  GetDscrCalculatorValueFn,
  UpdateDscrCalculatorValueFn,
  groupStandardCondition,
  constants,
  getCreditRateAdjustment,
  UpdateApplicationSfFn,
  TotalPaymentBreakupDialogData,
  calculateBusinessLoanEstimation,
  RatecardDetails,
  LoanTermValue,
  BusinessSearchResultValue,
  isAdminOrCreditUser,
  GetBankStatementsAnalysisFn,
  DownloadDocumentFromAzureFn,
  AssetSettlementGetApplicationAssetFn,
  GetBsaLenderListFn,
  GetBsaExcludedLenderListFn,
  SaveBsaCalculatorFn,
  GetBsaCalculatorFn,
  GetDscrCalculatorHistoryFn,
  GetBasiqCustomerMappingFn,
  GetBasiqStatementDataForCompanyFn,
  RefreshBasiqConnectionsFn,
  GetBankStatementAndBasiqDataStatusFn,
  GetOriginatorBusinessByIdFn,
  AddAuditLogFn,
  RunCreditFlowFn,
  GetCreditWebServicesFn,
  GetApplicationCreditFlowResultFn,
  DownloadCreditorWatchReportFn,
  UpdateCreditStatusFn,
  GetCreditAuditLogFn,
  ApplicationSelectionObject,
  GetWebServiceReportFn,
  GetDuplicatedApplicationsFn,
  DuplicatedApplication,
  DeleteWebServicesFn,
  getRepaymentType,
  RequestMoreInformationFn,
  WithdrawApplicationFn,
  GetApplicationDscrFn,
  UpdateCreditOfficerFn,
  GetActiveCreditUsersFn,
  ResendContractFn,
  AggregatorAndOriginatorListValueGetFn,
  GetUserByAccessLevelFn,
  GetApplicationSettlementsOfficerFn,
  GetAmlOfficerCandidatesFn,
  NewWebService,
  GetHistoricalContractsFn,
  GetPismoContractsFn,
} from '@portal-workspace/grow-shared-library';
import { BreadcrumbComponentEvent, BreadcrumbComponent } from '../../breadcrumb-component/breadcrumb.component';
import {RepaymentEstimationEntry} from '@portal-workspace/grow-shared-library';
import {AmortisationScheduleEntry} from '@portal-workspace/grow-shared-library';
import {PaymentChartData} from '@portal-workspace/grow-shared-library';
import {AmortizationChartData} from '@portal-workspace/grow-shared-library';
import {
  ApplicationDialogService,
  ApproveApplicationDocumentFn,
  BusinessSearchFn,
  CompleteDocumentWorklistFn,
  CreateDocumentWorklistFn,
  DeclineApplicationDocumentFn,
  DeleteApplicationDocumentFn,
  DigitalIdAddIndividualFn,
  DigitalIdSendVerificationSmsFn,
  DigitalIdUpdateApplicationIndividualDigitalIdMappingFn,
  SaveApplicationPartiesFn,
  DigitalIdVerifyOneApplicationIndividualFn,
  DownloadAllApplicationDocumentUrlFn,
  DownloadApplicationDocumentUrlFn,
  GetOriginatorByIdFn,
  getUser,
  ListApplicationDocumentFn,
  PortalHotToastService,
  UpdateApplicationDocumentTagsFn,
  UpdateApplicationRequiredDocumentsFn,
  GetNotesByApplicationIdFn,
  AssetSettlementSendAssetToSfFn,
  SearchSupplierFn,
  GetApplicationAuditLogsFn,
  BusinessNumberSearchFn,
  checkContractIndividuals,
  applicationDefaultDocuments,
  UndoApplicationDocumentFn,
  AssetSettlementSearchGrantorsFn,
  AssetSettlementGetPpsrDetailsFn,
  applicationToPaymentFrequency,
  applicationToLoanTerms,
  applicationToBrokerage,
  applicationToBusinessSearchValue,
  applicationToLoanAmount,
  applicationToPropertyOwner,
  applicationToBrokerageAmount,
  applicationToAdverseOnFile,
  applicationToEquifaxDirectorScoreMeetsThreshold,
  applicationToGstAgeMonths,
  applicationToGstAgeMonthsWithContinuity,
  applicationToDocFeeFinanced, applicationToDocFee, AssetDocumentsComponent,
  DscrCalculatorComponent,
} from '@portal-workspace/grow-ui-library';
import {ApplicationSelectionType, applicationEntityDisplayName} from '@portal-workspace/grow-shared-library';
import moment from 'moment';
import {setupUntilDestroy} from '@portal-workspace/grow-ui-library';
import {
  getAbn,
  getAcn,
  getAdverseOnFile,
  getApplicationNotes, getAssetCategory,
  getAssetCondition,
  getAssetDescription,
  getAssetFamily,
  getAssetMake, getAssetType, getAssetYear, getBrokerage,
  getBrokerApplicationId,
  getBrokerName, getBrokerOriginationFee,
  getBrokerSalesforceId,
  getCompanyName,
  getDeposit,
  getDocFeeFinanced,
  getEquifaxScoreAboveThresold,
  getFinanceType,
  getIndustrySector,
  getInterestRate,
  getInvoiceAmount,
  getLoanAmount,
  getLoanTerms,
  getOrganisationType, getPrimaryBusinessAddress,
  getPrivateSales,
  getPropertyOwner,
  getRepaymentFrequency,
  getRevenue,
  DigitalIdGetApplicationIndividualsFn,
  GetRateCardDetailsFn,
  getApplicationStage,
  DigitalIdUpdateIndividualKycStatusFn,
  DigitalIdSyncIndividualKycFromFrankieOneFn,
} from '@portal-workspace/grow-shared-library';
import {switchMap, tap} from 'rxjs/operators';
import {UntilDestroy} from '@ngneat/until-destroy';
import {combineLatest, of, Subscription} from 'rxjs';
import {isInternalUser} from '@portal-workspace/grow-shared-library';
import {UpdateApplicationDocumentFn} from '../application-details.module';
import {GetUsersByOriginatorBusinessIdFunc, UserSelectionComponentEvent} from '@portal-workspace/grow-ui-library';
import { BusinessDocumentsComponent } from './business-documents.component';
import { BusinessCreditComponent } from './business-credit.component';
import { KycVerificationComponent } from '../kyc-verification.component';
import { confirmLeaveKycAmlTab } from '../kyc-unsaved-tab-guard';
import { BusinessSettlementComponent } from './business-settlement.component';
import { BusinessAppComponent } from './business-app.component';
import {MatTabChangeEvent, MatTabsModule} from '@angular/material/tabs';
import { ApplicationStageIconComponent } from '../application-stage-icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';
import { LvrCalculatorComponent } from '../lvr-calculator.component';
import {BusinessPricingComponent, BusinessPricingComponentEvent} from "./business-pricing.component";
import { BankComponent } from '../bank.component';
import { MatExpansionModule } from "@angular/material/expansion";
import {ApplicationTypeIconComponent} from '../../application-type-icon/application-type-icon.component';
import { CreditReportComponent } from '../../credit-component/credit-report.component';
import { MessageBoxComponent } from '../../message-box/message-box.component';
import { ActivatedRoute } from '@angular/router';

export type BusinessTab = {selectionTypes: ApplicationSelectionType[], iconClass: string, name: string, index: number};

@UntilDestroy({arrayName: 'subscriptions'})
@Component({
  selector: 'business-finance-application-details',
  templateUrl: './business-finance-application-details.component.html',
  styleUrls: ['./business-finance-application-details.component.scss'],
  standalone: true,

  imports: [
    FlexModule,
    BreadcrumbComponent,
    MatButtonModule,
    MatFormFieldModule,
    MatTooltipModule,
    ApplicationStageIconComponent,
    MatTabsModule,
    BusinessAppComponent,
    BusinessSettlementComponent,
    KycVerificationComponent,
    BusinessDocumentsComponent,
    LvrCalculatorComponent,
    BusinessPricingComponent,
    BankComponent,
    AssetDocumentsComponent,
    MatExpansionModule,
    DscrCalculatorComponent,
    BusinessCreditComponent,
    ApplicationTypeIconComponent,
    CreditReportComponent,
    MessageBoxComponent,
],

})
export class BusinessFinanceApplicationDetailsComponent {

  tabs: BusinessTab[] = [];

  ratecard: RatecardDetails | null = null;

  // possible selections that can be access directly through URL
  possibleSelections: ApplicationSelectionType[] = ['app', 'quote', 'bank-statement', 'asset', 'credit','documents', 'kyc-aml', 'pricing', 'credit-report'];

  subscriptions: Subscription[] = [];

  @Input({required: true}) createNewDisbursementFn!: CreateNewDisbursementFn;
  @Input({required: true}) updateDisbursementFn!: UpdateDisbursementFn;
  @Input({required: true}) getDisbursementByApplicationIdFn!: GetDisbursementByApplicationIdFn;
  @Input({required: true}) syncDisbursementToSfFn!: SyncDisbursementToSfFn;
  @Input({required: true}) businessNumberSearchFn!: BusinessNumberSearchFn;
  @Input({required: true}) syncBankDetailsToSfFn!: SyncBankDetailsToSfFn;
  @Input({required: true}) sendAssetToSfFn!: AssetSettlementSendAssetToSfFn;
  @Input({required: true}) getApplicationAuditLogsFn!: GetApplicationAuditLogsFn;
  @Input({required: true}) getLvrCalculatorValueFn!: GetLvrCalculatorValueFn;
  @Input({required: true}) updateLvrCalculatorValueFn!: UpdateLvrCalculatorValueFn;
  @Input({required: true}) getDscrCalculatorValueFn!: GetDscrCalculatorValueFn;
  @Input({required: true}) updateDscrCalculatorValueFn!: UpdateDscrCalculatorValueFn;

  @Input({required: true}) getBankStatementsAnalysisFn!: GetBankStatementsAnalysisFn;
  @Input({required: true}) getOriginatorByIdFn!: GetOriginatorByIdFn;
  @Input({required: true}) addIndividualFn!: DigitalIdAddIndividualFn;
  @Input({required: true}) verifyOneApplicationIndividualFn!: DigitalIdVerifyOneApplicationIndividualFn;
  @Input({required: true}) sendVerificationSmsFn!: DigitalIdSendVerificationSmsFn;
  @Input({required: true}) getApplicationIndividualsFn!: DigitalIdGetApplicationIndividualsFn;
  @Input({required: true}) saveApplicationPartiesFn!: SaveApplicationPartiesFn;
  @Input({required: true}) businessSearchFn!: BusinessSearchFn;
  @Input({required: true}) updateApplicationIndividualDigitalIdMappingFn!: DigitalIdUpdateApplicationIndividualDigitalIdMappingFn;
  @Input({required: true}) listApplicationDocumentFn!: ListApplicationDocumentFn;
  @Input({required: true}) downloadApplicationDocumentUrlFn!: DownloadApplicationDocumentUrlFn;
  @Input({required: true}) approveApplicationDocumentFn!: ApproveApplicationDocumentFn;
  @Input({required: true}) declineApplicationDocumentFn!: DeclineApplicationDocumentFn;
  @Input({required: true}) deleteApplicationDocumentFn!: DeleteApplicationDocumentFn;
  @Input({required: true}) downloadAllApplicationDocumentUrlFn!: DownloadAllApplicationDocumentUrlFn;
  @Input({required: true}) updateApplicationDocumentTagsFn!: UpdateApplicationDocumentTagsFn;
  @Input({required: true}) updateApplicationRequiredDocumentsFn!: UpdateApplicationRequiredDocumentsFn;
   
  @Input({required: true}) createDocumentWorklistFn!: CreateDocumentWorklistFn;
  @Input({required: true}) completeDocumentWorklistFn!: CompleteDocumentWorklistFn;
  @Input({required: true}) getContractStatusFn!: GetContractStatusFn;
  @Input({required: true}) generateContractFn!: GenerateContractFn;
  @Input({required: true}) deleteContractFileFn!: DeleteContractFileFn;
  @Input({required: true}) getActiveContractForApplicationFn!: GetActiveContractForApplicationFn;
  @Input({required: true}) declineContractFn!: DeclineContractFn;
  @Input({required: true}) sendContractEmailsFn!: SendContractEmailsFn;
  @Input({required: true}) createApplicationNoteFn!: CreateApplicationNoteFn;
  @Input({required: true}) removeApplicationNoteByNoteIdFn!: RemoveApplicationNoteByNoteIdFn;
  @Input({required: true}) getNotesByApplicationIdFn!: GetNotesByApplicationIdFn;
  @Input({required: true}) syncContractDetailsToSfFn!: SyncContractDetailsToSfFn;
  @Input({required: true}) getBillerNameFn!: GetBillerNameFn;
  @Input({required: true}) validateBpayFn!: ValidateBPAYFn
  @Input({required: true}) updateApplicationStageFn!: UpdateApplicationStageInSfFn;
  @Input({required: true}) getApplicationByIdFn!: GetApplicationByIdFn;
  @Input({required: true}) getInstitutionNameFn!: GetInstitutionNameFn;
  @Input({required: true}) searchSupplierFn!: SearchSupplierFn;
  @Input({required: true}) generateApprovalNoticeFn!: GenerateApprovalNoticeFn;
  @Input({required: true}) sendApprovalNoticeEmailFn!: SendApprovalNoticeEmailFn;
  @Input({required: true}) deleteApprovalNoticeFileFn!: DeleteApprovalNoticeFileFn;
  @Input({required: true}) undoApplicationDocumentFn!: UndoApplicationDocumentFn;
  @Input({required: true}) getAccountDetailsFromSfFn!: GetAccountDetailsFromSfFn;
  @Input({required: true}) apiUrl!: string;
  @Input({required: true}) bankStatementsUrl!: string;
  @Input({required: true}) application!: BusinessLoansApplication;
  @Input({required: true}) refreshBankStatementFn!: RefreshBankStatementFn;
  @Input({required: true}) getUserFn!: GetUserFn;
  @Input({required: true}) searchGrantorsFn!: AssetSettlementSearchGrantorsFn;
  @Input({required: true}) getPpsrDetailsFn!: AssetSettlementGetPpsrDetailsFn;

  breadcrumbTrails: string[] = ['Applications'];
  activeContract: ContractDetails | null = null;

  @Input({required: false}) productionMode!: boolean;
  @Input({required: true}) onBreadcrumbEventsFn: (evt: BreadcrumbComponentEvent)=>void = (evt)=>{};
  @Input({required: true}) allowContractGeneration!: boolean;
  @Input({required: true}) updateApplicationFn!: UpdateApplicationFn;
  @Input({required: true}) updateApplicationSfFn!: UpdateApplicationSfFn;
  @Input({required: true}) downloadDocumentFromAzureFn!: DownloadDocumentFromAzureFn;
  @Input({required: true}) getApplicationAssetFn!: AssetSettlementGetApplicationAssetFn;
  @Input({required: true}) getBsaLenderListFn!: GetBsaLenderListFn;
  @Input({required: true}) getBsaExcludedLenderListFn!: GetBsaExcludedLenderListFn;
  @Input({required: true}) saveBsaCalculatorFn!: SaveBsaCalculatorFn;
  @Input({required: true}) getBsaCalculatorFn!: GetBsaCalculatorFn;
  @Input({required: true}) getDscrCalculatorHistoryFn!: GetDscrCalculatorHistoryFn;
  @Input({required: true}) getBankStatementAndBasiqDataStatusFn!: GetBankStatementAndBasiqDataStatusFn;
  @Input({required: true}) getBasiqCustomerMappingByAbnFn!: GetBasiqCustomerMappingFn;
  @Input({required: true}) getBasiqStatementDataForCompanyFn!: GetBasiqStatementDataForCompanyFn;
  @Input({required: true}) refreshBasiqConnectionsFn!: RefreshBasiqConnectionsFn;
  @Input({required: true}) getOriginatorBusinessByIdFn!: GetOriginatorBusinessByIdFn;
  @Input({required: true}) addAuditLogFn!: AddAuditLogFn;
  @Input({required: true}) runCreditFlowFn!: RunCreditFlowFn;
  @Input({required: true}) getCreditWebServicesFn!: GetCreditWebServicesFn;
  @Input({required: true}) getApplicationCreditFlowResultFn!: GetApplicationCreditFlowResultFn;
  @Input({required: true}) downloadCreditorWatchReportFn!: DownloadCreditorWatchReportFn;
  @Input({required: true}) updateCreditStatusFn!: UpdateCreditStatusFn;
  @Input({required: true}) updateCreditOfficerFn!: UpdateCreditOfficerFn;
  @Input({required: true}) getActiveCreditUsersFn!: GetActiveCreditUsersFn;
  @Input({required: true}) getCreditAuditLogFn!: GetCreditAuditLogFn;
  @Input({required: true}) getDuplicatedApplicationsFn!: GetDuplicatedApplicationsFn;
  @Input({required: true}) deleteWebServicesFn!: DeleteWebServicesFn;
  @Input({required: true}) requestMoreInformationFn!: RequestMoreInformationFn;
  @Input({required: true}) withdrawApplicationFn!: WithdrawApplicationFn;
  @Input({required: true}) getApplicationDscrFn!: GetApplicationDscrFn;
  @Input({required: true}) resendContractFn!: ResendContractFn;
  @Input({required: true}) getAggregatorsAndOriginatorsFn!: AggregatorAndOriginatorListValueGetFn;
  @Input({required: true}) getUserByAccessLevelFn!: GetUserByAccessLevelFn;
  @Input({required: true}) getApplicationSettlementsOfficerFn!: GetApplicationSettlementsOfficerFn;
  @Input() getAmlOfficerCandidatesFn?: GetAmlOfficerCandidatesFn;
  @Input({required: true}) getHistoricalContractsFn!: GetHistoricalContractsFn;
  @Input({required: true}) getPismoContractsFn!: GetPismoContractsFn;
  @Input({required: true}) updateIndividualKycStatusFn!: DigitalIdUpdateIndividualKycStatusFn;
  @Input() syncIndividualKycFromFrankieOneFn?: DigitalIdSyncIndividualKycFromFrankieOneFn;

  @Output() events = new EventEmitter<UserSelectionComponentEvent & {type: 'submitter' | 'additional-correspondent' | 'broker' | 'sales-contact' | 'credit-officer' | 'settlement' | 'aml-officer'}>();
  @Output() businessPricingEvents = new EventEmitter<BusinessPricingComponentEvent>();
  @Output() clickApplicationEvent = new EventEmitter<DuplicatedApplication>;  
  @Output() refreshCreditTabEvent = new EventEmitter<Application>;

  rst!: TotalPaymentBreakupDialogData
  repaymentEstimationData: RepaymentEstimationEntry[] = [];
  amortizationScheduleData: AmortisationScheduleEntry[] = [];
  paymentChartData: PaymentChartData = {
    amountFinanced: 0,
    totalInterest: 0,
    emiAmt: 0,
    paymentFrequency: 'Monthly',
    principalAmt: 0,
    interestAmt: 0,
    totalAmt: 0,
    loanTerm: 0,
    lvr: 0,
    rv: 0,
    brokerageAmount: 0,
    docFee: 0,
    brokerOriginationFee: 0,
    applicationType:'BusinessLoans'
  };
  amortizationChartData: AmortizationChartData = {
    estimatedDrawdownDate: moment(),
    annualData: [],
    quarterlyData: [],
  };
  calculationLog?: {log: string, rate?: number}[];

  currentSection: ApplicationSelectionType = 'app';
  currentSectionIndex: number = 0;
  getCompanyName = getCompanyName;
  getBrokerApplicationId = getBrokerApplicationId;
  getBrokerSalesforceId = getBrokerSalesforceId;
  getBrokerName = getBrokerName;
  getOrganisationType = getOrganisationType;
  getInterestRate = getInterestRate;
  getLoanAmount = getLoanAmount;
  getBrokerage = getBrokerage;
  getAbn = getAbn;
  getAcn = getAcn;
  getFinanceType = getFinanceType;
  getAssetCategory = getAssetCategory;
  getAssetType = getAssetType;
  getAssetMake = getAssetMake;
  getAssetFamily = getAssetFamily;
  getAssetYear = getAssetYear;
  getAssetDescription = getAssetDescription;
  getAssetCondition = getAssetCondition;
  getInvoiceAmount = getInvoiceAmount;
  getLoanTerms = getLoanTerms;
  getPrivateSales = getPrivateSales;
  getEquifaxScoreAboveThreshold = getEquifaxScoreAboveThresold;
  getAdverseOnFile = getAdverseOnFile;
  getPropertyOwner = getPropertyOwner;
  getDocFeeFinanced = getDocFeeFinanced;
  getRepaymentFrequency = getRepaymentFrequency;
  getDeposit = getDeposit;
  getRevenue = getRevenue;
  getIndustrySector = getIndustrySector;
  getApplicationNotes = getApplicationNotes;
  getPrimaryBusinessAddress = getPrimaryBusinessAddress;
  isInternalUser = isInternalUser;
  getApplicationStage = getApplicationStage;
  applicationStageAllowGenerateContract = applicationStageAllowGenerateContract;
  formGroupedDocumentData = formGroupedDocumentData;
  unclassifiedDocuments = unclassifiedDocuments;
  applicationStageAllowSettleLoan = applicationStageAllowSettleLoan;
  groupStandardCondition = groupStandardCondition;
  loggedInUser: User | null = getUser();

  isAdminOrCreditUser = false;
  isAdminOrCreditUserOrSalesAM = false;

  @Input({required: true}) uploadApplicationDocumentFn!: UpdateApplicationDocumentFn;
  @Input({required: true}) getRatecardDetailsFn!: GetRateCardDetailsFn;
  @Input({required: true}) getUsersInCompanyFn!: GetUsersByOriginatorBusinessIdFunc;
  @Input({required: false}) initialSelection: ApplicationSelectionType | null = null;
  @Input({required: true}) settleLoanFn!: SettleLoanFn;
  @Input({required: true}) getBankDetailsFromOpportunitySfFn!: GetBankDetailsFromOpportunitySfFn;
  @Input({required: true}) getWebServiceReportFn!: GetWebServiceReportFn;
  @Output() selectionEvent: EventEmitter<ApplicationSelectionObject> = new EventEmitter<ApplicationSelectionObject>();
  @Output() navigateToApplications = new EventEmitter();

  @ViewChild(KycVerificationComponent) kycVerification?: KycVerificationComponent;

  constructor(
    private toastService: PortalHotToastService,
    private dialogService: ApplicationDialogService,
    private activatedRoute: ActivatedRoute,
  ){}

  initTabs() {
    this.tabs = [];
    this.tabs.push({selectionTypes: ['app'], iconClass: 'mdi-view-grid-outline', name: 'APPLICATION', index: (this.tabs.length)});
    this.tabs.push({selectionTypes: ['bank-statement'], iconClass: 'mdi-bank-outline', name: 'BANK STATEMENTS', index: (this.tabs.length)});
    this.tabs.push({selectionTypes: ['kyc-aml'], iconClass: 'mdi-check-decagram-outline', name: 'CUSTOMER DETAILS(KYC/AML)', index: (this.tabs.length)});
    if (isInternalUser(this.loggedInUser)) {
      this.tabs.push({selectionTypes: ['credit', 'credit-report'], iconClass: 'mdi-calculator', name: 'CREDIT', index: (this.tabs.length)});
    }

    this.tabs.push({selectionTypes: ['documents'], iconClass: 'mdi-folder-outline', name: 'DOCUMENTS', index: (this.tabs.length)});
    this.tabs.push({selectionTypes: ['asset', 'add-asset'], iconClass: 'mdi-handshake-outline', name: 'CONTRACT', index: (this.tabs.length)});

    if (this.isAdminOrCreditUserOrSalesAM || isInternalUser(this.loggedInUser)) {
      this.tabs.push({selectionTypes: ['pricing'], iconClass: 'mdi-currency-usd', name: 'PRICING', index: (this.tabs.length)});
    }

  }

  hasUnsavedKycChanges(): boolean {
    return this.currentSection === 'kyc-aml' && !!this.kycVerification?.hasUnsavedChanges();
  }

  unsavedKycChangeLabels(): string[] {
    return this.kycVerification?.unsavedChangeLabels() ?? [];
  }

  async onSelectionTabChange(event: MatTabChangeEvent) {
    const previousSection = this.currentSection;
    const tabFound = this.tabs.find(t => t.index == event.index);
    const selection = tabFound ? tabFound.selectionTypes[0] : 'app' /* default selection if not found */ ;
    const canLeave = await confirmLeaveKycAmlTab({
      previousSection,
      nextSection: selection,
      kycVerification: this.kycVerification,
      dialogService: this.dialogService,
      revertToKycTab: () => {
        const kycTab = this.tabs.find(t => t.selectionTypes.includes('kyc-aml'));
        if (kycTab) {
          this.currentSectionIndex = kycTab.index;
        }
      },
    });
    if (!canLeave) {
      return;
    }
    this.currentSection = selection;
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }


  ngOnInit() {
    this.isAdminOrCreditUser = isAdminOrCreditUser(this.loggedInUser);
    this.isAdminOrCreditUserOrSalesAM = isAdminOrCreditUserOrSalesAM(this.loggedInUser);
    this.initTabs();
    const routeTab = this.initialSelection;
    if (routeTab && this.possibleSelections.includes(routeTab)) {
      const _tab = this.tabs.find(tab => tab.selectionTypes.includes(routeTab));
      if (_tab) {
        this.currentSection = routeTab;
        this.currentSectionIndex = _tab.index;
      }
    }
    setupUntilDestroy(this);
    this.getActiveContract()
    const entityName = applicationEntityDisplayName(this.application);
    if (entityName) {
      this.breadcrumbTrails.push(entityName);
    }
    const sub = this.getRatecardDetailsFn(this.application.UserId, 'BusinessLoans').pipe(
      this.toastService.spinnerObservable(),
      tap(r => {
        this.ratecard = r;
        this.recalculateEstimation();

        //   const bureauReport = (businessSearchValue as BusinessSearchResultValue /* HACK */).result ?? null;


      })).subscribe();

      this.subscriptions.push(this.businessPricingEvents.subscribe((evt) => {
        switch(evt.type) {
          case "business-pricing-saved": {
            this.rst = evt.rst;
            this.repaymentEstimationData = evt.rst.repaymentEstimationData;
            this.amortizationChartData = evt.rst.amortizationChartData;
            this.paymentChartData = evt.rst.paymentChartData;
            this.amortizationChartData = evt.rst.amortizationChartData;
            break;
          }
        }
      }));
   this.subscriptions.push(sub);
  }

  recalculateEstimation() {
    if (this.ratecard) {
      const ratecard = this.ratecard;
      const date = moment().add(1, 'day');

      {
        const paymentFrequencyValue = applicationToPaymentFrequency(this.application);
        const paymentFrequencyType = paymentFrequencyValue?.type ?? null;
        const loanAmount = applicationToLoanAmount(this.application) ?? 0;
        const loanTermValue: LoanTermValue = applicationToLoanTerms(this.application);
        const loanTermType = loanTermValue?.type ?? null;
        const brokerageValue = applicationToBrokerage(this.application);
        const brokerageType = brokerageValue?.type ?? null;
        const brokerageAmount = applicationToBrokerageAmount(this.application) ?? undefined;
        const businessSearchValue = applicationToBusinessSearchValue(this.application);
        const businessSearchValueWithSearchResult = businessSearchValue?.type == 'search-result' ? businessSearchValue : null;
        const propertyOwner =  applicationToPropertyOwner(this.application);
        const adverseOnFile = applicationToAdverseOnFile(this.application);
        const equifaxDirectorScoreAbove700 = applicationToEquifaxDirectorScoreMeetsThreshold(this.application, '>=700');
        const gstAgeMonths = applicationToGstAgeMonths(this.application);
        const gstAgeMonthsWithContinuity = applicationToGstAgeMonthsWithContinuity(this.application);
        const bureauReport = (businessSearchValue as BusinessSearchResultValue /* HACK */).result ?? null;
        const docFeeFinanced = applicationToDocFeeFinanced(this.application);
        const docFee = applicationToDocFee(this.application) as number;
        const paymentType = getPaymentType(this.application);
        const creditRateAdjustment = getCreditRateAdjustment(this.application);

        const rst = calculateBusinessLoanEstimation(date, {
          type: 'BusinessLoans',
          paymentFrequencyType: paymentFrequencyType,
          loanTermType: loanTermType,
          brokerageType: brokerageType,
          brokerage: brokerageAmount,
          loanAmount: loanAmount,
          businessSearchValue: businessSearchValueWithSearchResult,
          propertyOwner: propertyOwner,
          adverseOnFile: adverseOnFile,
          equifaxDirectorScoreAbove700,
          gstAgeMonths,
          gstAgeMonthsWithContinuity,
          rateCard: ratecard,
          bureauReport: bureauReport,
          brokerageAmount: brokerageAmount,
          docFeeFinanced: docFeeFinanced,
          docFee: docFee,
          paymentType: paymentType ?? undefined,
          creditRateAdjustment: creditRateAdjustment,
          repaymentType : getRepaymentType(this.application) ?? '',
        });

        this.rst = rst.totalPaymentBreakupDialogData;
        this.repaymentEstimationData = this.rst.repaymentEstimationData;
        this.amortizationScheduleData = this.rst.amortizationScheduleData;
        this.paymentChartData = this.rst.paymentChartData;
        this.amortizationChartData = this.rst.amortizationChartData;
        this.calculationLog = rst.totalPaymentBreakupDialogData.calculationLog;
      }
    }
  }

  onViewReport(element: NewWebService) {
    this.currentSection = 'credit-report';
    console.log(this.currentSection)
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: String(element.id),
    });
  }

  onLeaveReport(event: void) {
    this.currentSection = 'credit';
    this.selectionEvent.emit({
      selection: this.currentSection,
      innerTabParam: undefined,
    });
  }

  onBreadcurmbEvents($event: BreadcrumbComponentEvent) {
    this.onBreadcrumbEventsFn($event);
  }

  getActiveContract() {
    this.subscriptions.push(
      this.getActiveContractForApplicationFn(this.application.ApplicationId)
        .subscribe((r: ContractDetails | null) => {
          this.activeContract = r;
        })
    )
  }

  openGenerateContractDialog() {
    const ok = checkContractIndividuals(this.application, this.dialogService);
    if (ok) {
      this.subscriptions.push(
        this.dialogService.openGenerateContractDialog({
          sendContractEmailsFn: this.sendContractEmailsFn,
          getRatecardDetailsFn: this.getRatecardDetailsFn,
          getApplicationIndividualsFn: this.getApplicationIndividualsFn,
          generateContractFn: this.generateContractFn,
          deleteContractFileFn: this.deleteContractFileFn,
          application: (this.activatedRoute.snapshot.data as any).application,
          syncContractDetailsToSfFn: this.syncContractDetailsToSfFn,
          getAccountDetailsFromSfFn: this.getAccountDetailsFromSfFn,
          updateApplicationFn: this.updateApplicationFn,
          getOriginatorBusinessByIdFn: this.getOriginatorBusinessByIdFn,
          apiUrl: this.apiUrl,
        }).afterClosed().subscribe(() => {
          this.getActiveContract();
        })
      )
    }
  }

  onSettleLoan(){
    if (isInternalUser(this.loggedInUser)) {
      this.dialogService.openSettleLoanDialog()
        .afterClosed().pipe(
        tap(async (r) => {
          if (r) {
           this.doSendDisbursementToSf();
          }
        })
      ).subscribe()
    } else {
      // check documents first
      this.subscriptions.push(
        combineLatest([
          this.listApplicationDocumentFn(this.application.ApplicationId),
          this.getApplicationByIdFn(this.application.ApplicationId)
        ]).pipe(
          this.toastService.spinnerObservable()
        ).subscribe(([r, app]: [AzureStorageDocument[], Application]) => {
          if (r) {
            let docs: GroupedDocument[] = this.formGroupedDocumentData(r,
              app?.DocumentTypes?.length ? app?.DocumentTypes
              : [...applicationDefaultDocuments(this.application), this.unclassifiedDocuments()],
              '',
            );
            docs = this.groupStandardCondition(docs, this.application);
            docs = this.displayRequiredDocumentsOnly(docs);
            const otherDocs = docs.filter(d => d.otherCondition || (!d?.nonStandardCondition && !d?.standardCondition));
            const nonStandardConditionDocs = docs.filter(d => d?.nonStandardCondition);
            const standardConditionDocs = docs.filter(d => d?.standardCondition);
            const pendingGroups = [
              ...otherDocs.filter(group => (group.status ?? 'Pending') === 'Pending'),
              ...nonStandardConditionDocs.filter(group => (group.status ?? 'Pending') === 'Pending'),
              ...standardConditionDocs.filter(group => (group.status ?? 'Pending') === 'Pending')
            ];
            console.log(pendingGroups);
            if (pendingGroups.length) {
              // do not allow settle loan
              this.dialogService.openAlertDialog({
                message: 'Error',
                subMessage: 'You cannot settle loan as you still have pending documents',
              }).afterClosed().subscribe();
            } else {
              this.doUpdateApplicationStage();
            }
          }
        })
      )
    }
  }

  private displayRequiredDocumentsOnly(docs: GroupedDocument[]) {
    return docs.filter(group => {
      if (
        group.value === constants.documentTypes.internalDocuments.value ||
        group.required || group.docs?.length
      ) {
        return true;
      }
      return false;
    })
  }

  doUpdateApplicationStage() {
    this.subscriptions.push(
      this.updateApplicationStageFn({
        salesforceId: this.application.AppInfoSalesforceID ?? "",
        stageName: 'QA'
      }).pipe(
        this.toastService.spinnerObservable(),
      ).subscribe((response: ApiResponse) => {
        if (response.status) {
          this.dialogService.successDialog({
            message: 'Success',
            subMessage: "Application sent to QA queue",
          }).afterClosed().subscribe();
        } else {
          this.dialogService.openAlertDialog({
            message: 'Error',
            subMessage: response.message,
          }).afterClosed().subscribe();
        }
      })
    )
  }

  openContractStatusDialog() {
    this.subscriptions.push(
      this.dialogService.openContractStatusDialog({
        getContractStatusFn: this.getContractStatusFn,
        applicationId: this.application.ApplicationId,
        declineContractFn: this.declineContractFn,
        envelopeId: this.activeContract?.envelopeId ?? "",
        resendContractFn: this.resendContractFn,
      }).afterClosed().subscribe(() => {
        this.getActiveContract();
      })
    )
  }

  doSendDisbursementToSf() {
    this.subscriptions.push(
      this.getDisbursementByApplicationIdFn(this.application.ApplicationId).pipe(
        switchMap((disbursements: Disbursement[]) => {
          console.log('================disbursements', disbursements)
          // validate disbursements
          if (!validateDisbursementData(disbursements)) {
            return of({
              status: false,
              message: "Please make sure you enter payment details for all disbursements."
            })
          }
          return this.settleLoanFn({
            assets: [],
            disbursements: disbursements,
            salesforceId: this.application.AppInfoSalesforceID ?? ""
          })
        }),
        this.toastService.spinnerObservable(),
      ).subscribe((response: ApiResponse) => {
        if (response?.status) {
          this.dialogService.successDialog({
            message: "Success",
            subMessage: "Asset and disbursement details sent to Salesforce",
          }).afterClosed().subscribe()
        } else {
          this.dialogService.openAlertDialog({
            message: "Error",
            subMessage: response.message,
          }).afterClosed().subscribe()
        }
      })
    )
  }

  //           allSfData.push(sfData);
  //         }
  //         console.log("salesforce data: ", allSfData);
  //         return this.sendAssetToSfFn({
  //           records: allSfData
  //         })
  //       }),
  //     ).subscribe()
  //   )

  onBusinessPricingEvents($event: BusinessPricingComponentEvent) {
    this.businessPricingEvents.emit($event);
  }

  onClick(event: DuplicatedApplication) {
    this.clickApplicationEvent.emit(event);
  }

  refreshCreditTab(event: Application) {
    this.refreshCreditTabEvent.emit(event);
  }
}
